"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var qwest = _interopRequireWildcard(require("qwest"));
var _styles = require("@material-ui/core/styles");
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _getFormData = _interopRequireDefault(require("Components/Forms/Functions/getFormData"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const styles = theme => ({
  dialog: {
    height: 200,
    maxWidth: 500,
    width: '100%'
  }
});
class EditCompanyActivityModal extends _react.Component {
  state = {
    status_messages: {},
    'company_activity[label]': undefined
  };
  componentDidUpdate(prevProps, prevState) {
    const component = this,
      props = this.props,
      state = this.state;
    if (prevProps.id !== props.id) {
      qwest.post('/company-activity/get-all', {
        id: props.id
      }).then((xhr, response) => {
        component.setState({
          loading: false,
          'company_activity[label]': response.company_activities[0].label
        });
      }).catch((error, xhr, response) => {
        console.error(response?.error || response?.raw || error);
        component.setState({
          ...(0, _getErrorsFromResponse.default)({
            response: response
          })
        });
      });
    }
  }
  handleChange = _ref => {
    let {
      e,
      value,
      name
    } = _ref;
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages[name];
    component.setState({
      [name]: value,
      error: undefined,
      status_messages: status_messages
    });
  };
  handleClose = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      "company_activity[label]": undefined,
      info: undefined,
      error: undefined,
      warning: undefined
    });
    if (props.onClose) props.onClose();
  };
  handleOk = e => {
    const component = this,
      props = this.props,
      state = this.state;
    let company_activity_data = new FormData();
    company_activity_data.append('company_activity[id]', props.id);
    company_activity_data = (0, _getFormData.default)({
      form_data: company_activity_data,
      pattern: 'company_activity[',
      state: state
    });
    component.setState({
      loading: true
    });
    qwest.post('/company-activity/update', company_activity_data).then((xhr, response) => {
      component.setState({
        loading: false,
        'company_activity[label]': undefined,
        info: 'Succès de modification de l\'activité'
      });
      this.props.onClose();
    }).catch((error, xhr, response) => {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    let output = /*#__PURE__*/_react.default.createElement(_Dialog.default, {
      maxWidth: "xs",
      open: props.open,
      "aria-labelledby": "Edition d'une activit\xE9",
      classes: {
        paper: props.classes.dialog
      },
      onClose: props.onClose,
      disableBackdropClick: true
    }, /*#__PURE__*/_react.default.createElement(_DialogTitle.default, null, "Edition d'une activit\xE9"), /*#__PURE__*/_react.default.createElement(_DialogContent.default, null, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['company_activity[label]'],
      name: "company_activity[label]",
      label: "Nom de l'activit\xE9",
      status: state.status_messages
    }), status), /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
      onClick: component.handleOk,
      color: "primary"
    }, "Mettre \xE0 jour"), /*#__PURE__*/_react.default.createElement(_Button.default, {
      onClick: component.handleClose,
      color: "primary"
    }, "Annuler")));
    return output;
  }
}
EditCompanyActivityModal.propTypes = {
  onClose: _propTypes.default.func.isRequired,
  onValidation: _propTypes.default.func,
  open: _propTypes.default.bool,
  classes: _propTypes.default.object.isRequired
};
EditCompanyActivityModal.defaultProps = {
  open: false
};
var _default = exports.default = (0, _styles.withStyles)(styles)(EditCompanyActivityModal);
